import React from "react";
import CircleStatusIcon from "../components/CircleStatusIcon";

const StatusView = ({ lidarStatus, videoInputStatus }) => {
  const renderStatusTable = (title, statusData) => {
    // Ensure sorting by extracting numeric parts of the keys
    const sortedData = statusData?.data
      ? Object.entries(statusData.data).sort(
          ([keyA], [keyB]) =>
            parseInt(keyA.replace("camera", ""), 10) -
            parseInt(keyB.replace("camera", ""), 10)
        )
      : [];

    return (
      <div className="flex rounded-[4px] p-[10px] mt-[27px] w-[1536px] shadow-md overflow-hidden">
        <table className="w-full text-left">
          <thead className="bg-light-8">
            <tr>
              <th className="p-4 text-light-1 font-semibold text-md w-1/3">{title}</th>
              <th className="p-4 text-light-1 font-semibold text-md w-1/3">Data rate</th>
              <th className="p-4 text-light-1 font-semibold text-md w-1/3">Status</th>
            </tr>
          </thead>
          <tbody>
            {sortedData.map(([key, value], index) => {
              const mbPerSecond = value["bytes/s"]
                ? (value["bytes/s"] / 1024 / 1024).toFixed(2)
                : "N/A";

              const individualStatus =
                statusData.messages[0][key]?.status ?? false;

              return (
                <tr
                  key={key}
                  className={`${
                    index % 2 === 0 ? "bg-light-7" : "bg-light-8"
                  } hover:bg-gray-600`}
                >
                  <td className="p-4 text-light-3 text-sm">{key}</td>
                  <td className="p-4 text-light-3 text-sm">{mbPerSecond} MiB/s</td>
                  <td className="p-4 pl-12 text-light-3 text-md">
                    <CircleStatusIcon status={individualStatus} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="w-full h-screen p-8 flex flex-col bg-grey-928">
      <div className="flex-grow flex flex-col overflow-hidden">
        <div
          className="overflow-y-scroll hide-scrollbar bg-light-9"
          style={{
            maxHeight: "100%",
            paddingBottom: 0,
            marginBottom: 0,
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          {lidarStatus && renderStatusTable("Lidar", lidarStatus)}
          {videoInputStatus &&
            renderStatusTable("Video Input", videoInputStatus)}
        </div>
      </div>
    </div>
  );
};

export default StatusView;
